import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { DATOS_API } from 'app/auth/auth.datos';

@Injectable({
  providedIn: 'root'
})
export class ConfiguracionVozService {

  constructor(private http: HttpClient) { }

  getIdiomasProd(fecha: any){
    return this.http.post(DATOS_API.url + DATOS_API.endpoints.getIdiomasGuardados + localStorage.getItem('companyID'), fecha);
  }

  getVoices(){
    return this.http.get(DATOS_API.url + DATOS_API.endpoints.getVoices + localStorage.getItem('companyID') + '/' + localStorage.getItem('productoID'));
  }

  getFormVoices(){
    return this.http.get(DATOS_API.url + DATOS_API.endpoints.getFormVoices + localStorage.getItem('productoID'));
  }

  saveFormVoices(datos:any){
    return this.http.post(DATOS_API.url + DATOS_API.endpoints.saveFormVoices + localStorage.getItem('companyID'), datos);
  }

  generaAudioPregunta(datos:any){
    return this.http.post(DATOS_API.url + DATOS_API.endpoints.tts, datos);
  }

  setSeccionesCuestionario(surveyProductId:any, secciones:any){
    return this.http.post(DATOS_API.url + DATOS_API.endpoints.seccionesCatMaster.setSeccionesCuestionario + surveyProductId, secciones);
  }

  getStatusPaso(anio: any){
    let datos: any = {productoId: anio,	voice: 1};
    return this.http.post(DATOS_API.url + DATOS_API.endpoints.getStatusPart + localStorage.getItem('companyID'), datos);
  }

  guardaStatusPaso(datos){
    return this.http.post(DATOS_API.url + DATOS_API.endpoints.guardaStatus + localStorage.getItem('companyID'), datos);
  }

  updateWithAudios(datos){
    return this.http.post(DATOS_API.url + DATOS_API.endpoints.updateWithAudios, datos);
  }
}
